import React, { useEffect, useState } from 'react';
import { checkAuth, getUserType } from '../utils/common';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LOGIN } from '../helpers/Constant';

function PrivateRoute() {
    const navigate = useNavigate();
    const location = useLocation();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isCancelled = false;

        const checkLogin = async () => {
            const userType = getUserType();

            if (userType === "guest_user") {
                if (!isCancelled) {
                    setUserData(null);
                    setLoading(false);
                }
                return;
            }

            const user = await checkAuth();
            if (isCancelled) return;

            if (!user) {
                navigate(`/${LOGIN}`);
                return;
            }

            setUserData(user);
            setLoading(false);
        };

        checkLogin();

        return () => {
            isCancelled = true;
        };
    }, [location.pathname, navigate]);

    if (loading) return null;
    if (getUserType() === "guest_user" || userData) return <Outlet />;
    return null;
}

export default PrivateRoute;

